// extracted by mini-css-extract-plugin
export var actions = "_mb-5";
export var assistantBubble = "_mb-3";
export var assistantRow = "_mb-6";
export var bubble = "_mb-0";
export var humanAvatar = "_mb-4";
export var inlineToolCard = "_mb-1";
export var userBubble = "_mb-2";